import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getProducts = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Product/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};

// Helper function to clean identity column ID fields from payload
const cleanIdentityColumns = (data) => {
  if (!data || typeof data !== 'object') return data;
  
  const cleaned = { ...data };
  
  // Remove product_Id if it's 0 or null (identity column)
  if (cleaned.product_Id !== undefined && (cleaned.product_Id === 0 || cleaned.product_Id === null)) {
    delete cleaned.product_Id;
  }
  // Also check for camelCase variant
  if (cleaned.productId !== undefined && (cleaned.productId === 0 || cleaned.productId === null)) {
    delete cleaned.productId;
  }
  
  // Note: ProductTaxes are created on backend from taxIds array, so no ProductTaxesid field to clean here
  
  return cleaned;
};

export const saveProduct = async (product) => {
  // Clean identity column ID fields before sending to backend
  const cleanedPayload = cleanIdentityColumns(product);
  
  const response = await axios.post(`${BASE_URL}/api/Product/save`, cleanedPayload, {
    headers: getAuthHeader(),
  });
  return response.data;
};

// API to search products with pagination and search text
export const searchProducts = async (searchText, page = 1, pageSize = 20) => {
  try {
    console.log('🌐 API Call - searchProducts:', {
      url: `${BASE_URL}/api/Product/search`,
      payload: { searchText, page, pageSize, activeOnly: true },
      headers: getAuthHeader()
    });
    
    const response = await axios.post(`${BASE_URL}/api/Product/search`, {
      searchText: searchText,
      page: page,
      pageSize: pageSize,
      activeOnly: true
    }, {
      headers: getAuthHeader(),
    });
    
    console.log('🌐 API Response - searchProducts:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ API Error - searchProducts:", error);
    console.error("❌ Error details:", {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data
    });
    throw error;
  }
};

// API to export products to Excel
export const exportProductsToExcel = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Product/export-excel`, filter, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `ProductReport_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting products:", error);
    throw error;
  }
}; 